import React from 'react';
import Routes from '../routes/routes';
import QualtricsFeedback from './qualtrics/QualtricsFeedback';

function App() {
	return (
		<>
			<Routes />
			<QualtricsFeedback />
		</>
	);
};

export default App;